let bearerToken: string | undefined;

const isLikelyJwt = (token: string): boolean => {
  const parts = token.split('.');
  return parts.length === 3 && parts.every(part => part.length > 0);
};

export const setToken = (token: string): void => {
  if (!isLikelyJwt(token)) {
    console.info('[play] Ignoring token from hash: not a JWT-like string');
    return;
  }
  console.info('[play] JWT stored in tokenStore (length: %d)', token.length);
  bearerToken = token;
};

export const getToken = (): string | undefined => bearerToken;

export const clearToken = (): void => {
  bearerToken = undefined;
};
